<template>
    <div > 
    	<div class="col-12 mt-4" :class="$parent.transfetWallet?'d-none':' '">
        	<h2 class="mb-3">{{$t('redeamP_your_points')}}</h2>
        	<div class="row redeeemPOints justify-content-center membchipMeal">
        		<!-- <div>
        			<h4 class="card-title">{{list.points}} Points</h4>
                    <p class="card-text">{{list.discription}}</p>
        		</div> -->
                <div class="col-12 col-md-3 text-center wow flipInX mb-4" v-for="list in loyalty_Points" :class="(parseInt(list.points) <= parseInt(loyalityCardDetail[0].active_points))? 'active' : 'disabled'">
                    <div class="card d-block border-0 customHover py-3 h-100 mb-0">
                        <img class="card-img-custom" :src="'../../../../../../static/fxView/images/'+list.image" alt="Trading">
                        <div class="card-body p-2">
                            <h4 class="card-title">{{numberWithCommas(list.points)}} {{$t('redeamP_Points')}}</h4>
                            <p class="card-text">{{list.discription}}</p>
                            <a href="#" class="btn darkBG" @click.prevent="redeam = list ; transaction_id = ''"  v-if="parseInt(list.points) <= parseInt(loyalityCardDetail[0].active_points)">{{$t('redeamP_Redeem')}}</a>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>



		<div class=" modal-popup" v-if="Object.keys(redeam).length > 0">
			<div class="row w-100 justify-content-center align-items-center">
				<div class="col-12 mb-3 middleBox">
					<div class="customPp">
		                <button @click.prevent="redeam = {}" type="button" class="close d-flex align-items-center justify-content-center" >
		                  <span aria-hidden="true">&times;</span>
		                </button>
		            </div>
					<div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && authComponent && transaction_id != '' && !congModuleIntTransfer)">
						<app-twofa  :call_from="request_page"></app-twofa>
					</div>
					<div class="whiteBG p-4 "  v-else>
						<div class="mainTitle text-center mt-4 mb-3"> 
							<h2 class="mb-3">{{$t('redeamP_Red_Points')}} </h2>
							<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
							<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
						</div> 

						<div class="CustomBlockWidth inMiddle-area whitebox p-4"> 
							<div class="justify-content-center"> 
								<div class="partcipate-fund d-flex justify-content-center align-items-center text-center" v-if="transaction_id == '' && !congModuleIntTransfer">
									<div>
					                    <div class="slctcurrency">
					                    	
				                            <figure>
				                            	<img class="Redeam-img-custom" :src="'../../../../../../static/fxView/images/'+redeam.image" alt="Trading">
				                            </figure>
				                            <div class="card-body p-2">
				                                <h4 class="card-title">{{numberWithCommas(redeam.points)}} {{$t('redeamP_Points')}}</h4>
				                                <p class="card-text">{{redeam.discription}}</p>
				                            </div>
				                        </div>
					                    
					                    <div class="full-width submitButton w-100 ">
					                        <button class="prism_btn btn_sm" v-on:click.prevent="redeamPoint()">{{$t('redeamP_Now')}}</button>
					                    </div>
					                </div>
								</div>


								<div class="partcipate-fund" v-if="transaction_id != '' && !congModuleIntTransfer">
									<div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 1)">
										<p class="mb-3 text-center">{{$t('rb_googleAuth1')}} <strong>{{$t('rb_googleAuth2')}}</strong> {{$t('rb_googleAuth3')}}. </p>
										<div class="form-group field-wrapper">
											<input type="text" placeholder="000 000" class="mdb-select md-form form-control" v-model="otp" v-validate="{ required: true, max: 6,numeric : true }" name="otp"  :class="{ 'is-invalid': submittedInternalOtp && errors.has('otp') }" ref="otpInput">
											<ul><li v-for="error in errors.collect('otp')">{{ error }}</li></ul>
										</div> 
										<div class="form-group text-center field-wrapper">
											<button class="prism_btn btn_sm " v-on:click.prevent="cofirmOtp()">{{$t('rb_validate')}}  </button>
										</div>
										<div class="clearfix"></div>
										<div class="d-flex align-items-center justify-content-between border-top pt-3 mt-3"> 
											<div class="desc text-center">
												<p>{{$t('rb_googleAuth4')}} <a v-on:click.prevent="resendLink()" href="#"><strong>{{$t('rb_googleAuth5')}}</strong></a></p>
											</div>
										</div>
										<div class="clearfix"></div>
									</div>
									<div class="middleBox1 " v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && !authComponent)">
										<div class="congratulations">
											<div class="logo_congrats">
												<img src="../../../../../static/fxView/images/internal_transfer.svg" alt="Icon">
											</div>
											<div class="subtitle">
												<p class="mb-3">{{$t('verf_dear')}} <strong class="green">{{get_user.username}}</strong>
													{{$t('rb_googleAuth6')}} <strong>{{get_user.email}} . </strong> {{$t('loyalP_intTransMsz2')}}
												</p>
												<a v-on:click.prevent="resendLink()" href="#" class="mb-3"><strong>{{$t('rb_googleAuth7')}}</strong></a>
												
											</div>
										</div>
										<div class="clearfix"></div>
										<div class="d-flex align-items-center justify-content-between enble2fa border-top pt-3 mt-3">
											<div class="ico mr-3">
												<img src="../../../../../static/fxView/images/google_auth.png" alt="2fa">
											</div>
											<div class="desc w-75">
												<h5 class="mb-2"><strong>{{$t('rb_googleAuth8')}}</strong></h5>
												<p>{{$t('rb_googleAuth9')}} <a v-on:click.prevent="authComponent = true" href="#"><strong>{{$t('rb_googleAuth10')}}</strong></a></p>
											</div>
										</div>
									</div> 
								</div> 

								<div class="stepForm " v-if="congModuleIntTransfer">
									<div class="congratulations">
										<div class="logo_congrats">
											<img src="../../../../../static/fxView/images/check.svg" alt="Icon">
										</div>
										<div class="subtitle">
											<h3>{{$t('rb_congo')}}  <span class="green">{{get_user.username}}</span></h3>
											<p>{{$t('loyalP_intTransMsz3')}} </p>
											<!-- <ul class="includeWdth">
												<li><strong>{{$t('fromTradId')}} </strong> {{res_data.account_id}}</li>
												<li><strong>{{$t('amount')}} </strong> {{parseFloat(res_data.amount).toFixed(2)}}</li>
												<li><strong>{{$t('toTradId')}} </strong>{{res_data.to_account_id}}</li>
												<li><strong>{{$t('transferAmount')}} </strong>{{parseFloat(res_data.trans_amount).toFixed(2)}}</li>
											</ul> -->
										</div>
									</div>
									<!-- <div class="signupbtn full-width submitButton w-100 mt-4 text-center">
										<router-link :to="'/account-list'" class="prism_btn btn_sm">{{$t('goBackMangeAcc')}} </router-link>
									</div>  -->
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
	    </div>
    </div>
</template>
<script>
	import {loyalty_Points} from '../../../../../static/fxView/js/loyalty_Points.js'
	import twoFa from '../../users/2FA'
    export default {
        name: 'Redeam-points',
        data() {
            return {
				pageName : 'subscribe-account',
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                //==========================================
              

                otp : '',
                submittedInternalOtp : false,

                

                loyalty_Points: loyalty_Points,
                redeam:{},


                
                transaction_id : '',
                congModuleIntTransfer : false,
                 authComponent : false,
            }
        },
        components: {
            appTwofa: twoFa
        },
        methods:{
            resendLink(){
            	let input_json={
					'globalParams' :{
						'trans_id' : this.transaction_id.toString()
					},
					'localParams' :{ "parameter" : this }
				}
            	if(parseInt(this.redeam.id) >= 3 &&  parseInt(this.redeam.id) <= 5){
            		this._runSubOperLink(input_json)
            	}else{
            		this._runLoyalityResendOtp(input_json)
            	}
			},
            //==================password===================
            redeamPoint(){
            	if(parseInt(this.redeam.id) >= 3 &&  parseInt(this.redeam.id) <= 5){
            		let input_json={
	                    'globalParams' :{
	                       'account_id' : '' ,
							"act_account_id" : '',
							"plan_id" : 6,
							"detail_id" : parseInt(this.redeam.detal_id),
							'operation' : 'LOYALITY_VPS',
							"couponcode": -1
	                    },
	                    'localParams' :{ "parameter" : this}
	                }
	                this._runSubOperation(input_json)
            	}else{
            		let input_json={
	                    'globalParams' :{
	                        subject: 'Redeem Wallet Points',
							text: this.$t('redeamP_walletpoints')+this.redeam.points+this.$t('redeamP_pointdesc')+this.redeam.discription,
							points : this.redeam.points, //dynamic
							active_points : this.loyalityCardDetail[0].active_points,
							point_desc : this.redeam.discription, //dynamic
							reason: 118,
							reason_text: 'Redeem_Wallet_Points',
							title: 0,
							title_text: '',
							"operation" : "REDEEM LOYALTY"
	                    },
	                    'localParams' :{ "parameter" : this}
	                }
	                this._runLoyalityRequestOtp(input_json)
            	}

               
            },
            cofirmOtp(){
                const _that = this
                this.submittedInternalOtp = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
                    	if(parseInt(this.redeam.id) >= 3 &&  parseInt(this.redeam.id) <= 5){
                    		let input_json={
	                            'globalParams' :{
	                                'google_token' : _that.otp.toString() ,
	                                'trans_id' : _that.transaction_id.toString()
	                            },
	                            'localParams' :{ "parameter" : _that , "plan_id" : 6,"detail_id" : parseInt(_that.redeam.detal_id)}
	                        }
	                        _that._runCreateSubTicket(input_json)
                    	}else{
                    		let input_json={
	                            'globalParams' :{
	                                'otp' : _that.otp.toString() ,
	                                'trans_id' : _that.transaction_id.toString()
	                            },
	                            'localParams' :{ "parameter" : _that,page:'subscribe' }
	                        }
	                        _that._runLoyalityRedeemCheckOtp(input_json)
                    	}
                        
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
            reset(){
                this.otp = ''
                this.submittedInternalOtp = false
                this.redeam = {}
                this.transaction_id = ''
                this.congModuleIntTransfer = false
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/wallet/loyality/redeam-point.vue